import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NinjaCumulativeData, NinjaData } from '../models/ninja-data.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DailyWorldData } from '../models/daily-world-data.model';
import { map, shareReplay } from 'rxjs/operators';
import { Vaccine } from './vaccines/vaccine.model';
import { Therapeutic } from './therapeutics/therapeutic.model';
import { CountryHistoricalData } from '../models/country-historical-data.model';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient) {
  }

  getCumulativeData(): Observable<NinjaCumulativeData> {
    return this.http.get<NinjaCumulativeData>(environment.cumulativeDataUrl);
  }

  getSortedCountries(): Observable<NinjaData[]> {
    return this.http.get<NinjaData[]>(environment.ninja + 'countries?sort=cases')
      .pipe(
        shareReplay()
      );
  }

  getContinentsData(): Observable<NinjaData[]> {
    return this.http.get<NinjaData[]>(environment.ninja + 'continents?yesterday=true&sort');
  }

  getCountryDetails(name: string): Observable<NinjaData> {
    return this.http.get<NinjaData>(`${environment.ninja}countries/${name}`)
      .pipe(
        shareReplay()
      );
  }

  getCountryPopulation(name: string): Observable<number> {
    return this.http.get<NinjaData>(`${environment.ninja}countries/${name}`)
      .pipe(
        map(country => country.population)
      );
  }

  getCountryHistoricalData(name: string): Observable<CountryHistoricalData> {
    return this.http.get<CountryHistoricalData>(environment.countryHistorical + name + '?lastdays=700')
      .pipe(
        shareReplay()
      );
  }

  getDiseaseHistoricalData(): Observable<any[]> {
    return this.http.get<any[]>(environment.dailyTimeSeriesUrlDiseaseSh)
      .pipe(
        shareReplay()
      );
  }

  getVaccines(): Observable<Vaccine[]> {
    return this.http.get<{ data: Vaccine[] }>(environment.vaccinesUrl)
      .pipe(
        map(res => res.data)
      );
  }

  getWorldVaccinesCoverage(): any {
    const endpoint = environment.vaccinesCoverageUrl + 'coverage?lastdays=500';
    return this.http.get<any>(endpoint).pipe(
      shareReplay()
    );
  }

  getVaccinesCoverageByCountry(country: string): any {
    const endpoint = environment.vaccinesCoverageUrl + 'coverage/countries/' + country + '?lastdays=500';
    return this.http.get<any>(endpoint).pipe(
      shareReplay()
    );
  }


  getTherapeutics(): Observable<Therapeutic[]> {
    return this.http.get<{ data: Therapeutic[] }>(environment.therapeuticsUrl)
      .pipe(
        map(res => res.data)
      );
  }

  getWorldTimeSeries(): Observable<DailyWorldData[]> {
    return this.http.get<DailyWorldData[]>(environment.dailyTimeSeriesUrl);
  }

  // getMobilityData(): Observable<any[]> {
  //   return this.http.get<any[]>(environment.athensMobilityData);
  // }


}
